import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Subscription, delay, of } from 'rxjs';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AmcService } from '../../services/amc.service';
import { ModalDismissReasons, NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],


})
export class MainComponent {
  bannerMessage = "";
  showBanner = false;
  hideblockBanner = "hide";
  isAmcLoading = true;
  tokenSubscription = new Subscription()
  @ViewChild('noshow') noshowModal: any;
  @ViewChild('drawer', { static: true }) public drawer!: MatDrawer;
  @Output("toggleMenu") toggleMenu: EventEmitter<any> = new EventEmitter();
  constructor(private jwt:JWTTokenServiceService,private router:Router,private modalService: NgbModal, private localStorage:LocalStorageService,private api:AmcService)
  {

    // if (jwt.getToken()=="") {
    //    router.navigate(['login']);    
    // }
    // if(jwt.isTokenExpired())
    // {
    //   this.router.navigate(['login']);
    // }
    // console.log(jwt.getExpiryTime())
    /// this.expirationCounter(jwt.getExpiryTime());
    //console.log(jwt.getDecodeToken())
    this.checkAmc();
  } 
  
  ngOnInit(): void {
    // checking idf router params contains apointments or not
    // this.checkAmc();

  }

  ngAfterViewInit() {
   
  }

  hideModalBanner(){
    this.modalService.open(this.noshowModal,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {  
      if (result === 'yes') {  

      }  
    }, (reason) => {  
    }); 
  }

  hideBanner() {
    this.showBanner = false;
  }

  expirationCounter(timeout:any) {
    this.tokenSubscription.unsubscribe();
    this.tokenSubscription = of(null).pipe(delay(timeout)).subscribe((expired) => {
      console.log('EXPIRED!!');
      this.logout();
    });
  }

  logout() {
    this.tokenSubscription.unsubscribe();
    this.localStorage.logout();
    this.router.navigate(["/login"]);
  }
  
  async checkAmc() {
    let param = {
        "hospital_id": this.localStorage.getHospitalId()
    }
    this.api.getAMCStatus(param).subscribe({
      next:(response)=>{
         console.log(response);
         this.isAmcLoading = false;
         if(response) {
          if(response.aboutToExpire.message) {
            this.bannerMessage = response.aboutToExpire.message;
            this.showBanner = false;
            this.hideblockBanner = "show";
            this.hideModalBanner();
          }
          if(response.isGracePeriod.message) {
            this.bannerMessage = response.isGracePeriod.message;
            this.showBanner = true;
            this.hideblockBanner = "show";
          }
          if(response.isExpired.message) {
            this.bannerMessage = response.isExpired.message;
            this.hideblockBanner = "hide";
            this.showBanner = false;
          }
          else {
            this.hideblockBanner = "show";
          }
         }
      },
      error:(e)=>{
        this.isAmcLoading = false;
      }
    })
  }

}
